import { render, staticRenderFns } from "./MarketingChargeCreate.vue?vue&type=template&id=66736f68&scoped=true&"
import script from "./MarketingChargeCreate.vue?vue&type=script&lang=js&"
export * from "./MarketingChargeCreate.vue?vue&type=script&lang=js&"
import style0 from "./MarketingChargeCreate.vue?vue&type=style&index=0&id=66736f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66736f68",
  null
  
)

export default component.exports